import { useMemo } from 'react';

import { GET_CARDS_QUERY_PARAMS_KEYS, ROOT_DEPENDENT_ID } from  '@/modules/transaction/components/Cards/Cards.constants.ts';

export const useQueryGenerator = (
  employeeId?: number | string | null,
  dependentId?: number | string | null,
) => {
  return useMemo(() => {
    const queryGenerator = new URLSearchParams();

    if (employeeId) {
      queryGenerator.set(GET_CARDS_QUERY_PARAMS_KEYS.EMPLOYEE_ID, `${employeeId}`);
    }

    if (dependentId && dependentId !== ROOT_DEPENDENT_ID) {
      queryGenerator.set(GET_CARDS_QUERY_PARAMS_KEYS.DEPENDENT_ID, `${dependentId || ROOT_DEPENDENT_ID}`);
    }

    return queryGenerator;
  }, [employeeId, dependentId]);
};
